/**************************************************************
Alexander Self
Team Actions
8/22/17
**************************************************************/
import { ADD_GANG_MEMBER, REMOVE_GANG_MEMBER, GANG_AUTOCOMPLETE, CREATE_GANG,
  FETCH_GANGS, SELECT_GANG, SELECT_GANG_TO_EDIT, ADD_GANG_MEMBER_TO_EDIT, REMOVE_GANG_MEMBER_FROM_EDIT,
  EDIT_GANG, GANG_EDIT_AUTOCOMPLETE, DELETE_GANG } from './types';
import { error } from './index';
import { ROOT_URL } from '../constants';
import axios from 'axios';
const Materialize = window.Materialize;
const $ = window.$;
/********************** Asynchronous Function *********************************/
/* Creates a new gang
   Called in components/gangs/create/gang_create.js
*/
export function createGang(emps, gangs) {
  const gangId = document.getElementById('gang-builder-No').value;
  const gangLoc = document.getElementById('gang-builder-location').value;
  const gangCount = emps.length;

  if (!(gangId && gangLoc)) return error('Please add a Gang No. and Gang Location');
  if (gangCount === 0) return error('Please add at least one employee to create a gang.');
  for (const g of gangs) { if (g.gangId === gangId) return error('Gang No. is taken. Please try again.') }
  document.getElementById('gang-builder-No').value = '';
  document.getElementById('gang-builder-location').value = '';
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/createGang`, { gangId, gangLoc, gangCount, emps })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.msg, 4000, 'rounded green');
        dispatch({type: CREATE_GANG, payload: res.gangs, selectedEmps: emps});
      }).catch((err) => dispatch(error(`There was an error creating a new gang. Please try another Gang No.`)))
  }
}
/* Fetches gangs from the server */
export function fetchGangs() {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchGangs`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({type: FETCH_GANGS, payload: res.gangs});
      }).catch((err) => dispatch(error(`There was an error fetching gangs`)));
  }
}
/* Submits a gang for editing */
export function editGang(gang) {
  let tempGangId = document.getElementById('edit-gang-builder-gangId').value;
  let tempGangLoc = document.getElementById('edit-gang-builder-gangLoc').value;
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/editGang`, { gang, tempGangId, tempGangLoc })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.msg, 4000, 'rounded green');
        dispatch({type: EDIT_GANG, payload: res.gangs});
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error editing a gang`));
      });
  }
}

export function deleteGang(gang) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/deleteGang`, { gang })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.msg, 4000, 'rounded green');
        dispatch({ type: DELETE_GANG, payload: res.gangs, oldGang: gang });
      }).catch(err => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error deleting a gang`));
      })
  }
}

/********************** Synchronous Function **********************************/
/* Adds a gang member to the viewing table during create */
export function addGangMember(emp) {
  return {
    type: ADD_GANG_MEMBER,
    payload: emp
  }
}
/* Removes a gang member from the table during create */
export function removeGangMember(emp) {
  return {
    type: REMOVE_GANG_MEMBER,
    payload: emp
  }
}
/* Adds a member to a gang using the autocomplete */
export function gangAutocomplete(e, id) {
  document.getElementById(id).value = '';

  return {
    type: GANG_AUTOCOMPLETE,
    payload: e
  };
}

/* Adds a member to a gang using the autocomplete */
export function gangEditAutocomplete(e, id) {
  document.getElementById(id).value = '';
  return {
    type: GANG_EDIT_AUTOCOMPLETE,
    payload: e
  };
}

/* Selects a gang for viewing */
export function selectGang(gangId) {
  return {
    type: SELECT_GANG,
    payload: gangId
  };
}

/* Selects a gang to edit */
export function selectGangToEdit(gangId) {
  return {
    type: SELECT_GANG_TO_EDIT,
    payload: gangId
  }
}

/* Removes a gang member from table and adds to employee list */
export function removeGangMemberFromEdit(emp) {
  return {
    type: REMOVE_GANG_MEMBER_FROM_EDIT,
    payload: emp
  };
}
/* Adds an employee to a gang during editing */
export function addGangMemberToEdit(emp, selectedGang) {
  // Make sure a gang is selected prior to adding an employee
  if (Object.keys(selectedGang).length <= 1) return error('Please select a gang before adding an employee');
  return {
    type: ADD_GANG_MEMBER_TO_EDIT,
    payload: emp
  };
}
























/* END */



// WEBPACK FOOTER //
// ./src/actions/team_actions.js